<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <p class="mb-3">{{ $t("registerPage.selection-competences-indications") }}</p>

    <GroupCheckboxesWithValidation
      v-model="checkedCompetenceStrings"
      vid="competences"
      rules="required"
      :data="competencesStrings"
      :vertical-display="true"
      @update:model-value="changeCompetences"
    />

    <div class="buttons mt-5">
      <b-button type="is-dark" @click="goBack">
        {{ $t("registerPage.precedent") }}
      </b-button>
      <b-button type="is-primary" @click="handleSubmit(submit)">
        {{ $t("registerPage.suivant") }}
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import GroupCheckboxesWithValidation from "@/views/inputs/GroupCheckBoxesWithValidation.vue"
import { UtilisateurRegistrationDTO } from "@/model/bean/GeneratedDTOs"
import { t } from "@/utils/i18n-utils"
import { BButton } from "buefy"

const COMPETENCES_STRINGS = {
  PEDAGOGIE: t("profilePage.competences-referent.pedagogie"),
  ECOLOGIE: t("profilePage.competences-referent.ecologie"),
  AE: t("profilePage.competences-referent.ae"),
}

export default defineComponent({
  name: "ReferentCompetencesView",
  components: {
    ValidationObserver,
    GroupCheckboxesWithValidation,
    BButton,
  },

  props: {
    modelValue: {
      type: Object as () => UtilisateurRegistrationDTO,
      required: true,
    },
  },

  emits: ["update:model-value", "go-back"],
  data() {
    return {
      innerUtilisateur: { ...this.modelValue } as UtilisateurRegistrationDTO,
      competencesStrings: Object.values(COMPETENCES_STRINGS),
      checkedCompetenceStrings: [] as string[],
    }
  },
  mounted() {
    // Initialize checked competences based on user's existing competences
    const checked: string[] = []
    if (this.modelValue.competencesReferentPedagogie) {
      checked.push(COMPETENCES_STRINGS.PEDAGOGIE)
    }
    if (this.modelValue.competencesReferentEcologie) {
      checked.push(COMPETENCES_STRINGS.ECOLOGIE)
    }
    if (this.modelValue.competencesReferentAe) {
      checked.push(COMPETENCES_STRINGS.AE)
    }
    this.checkedCompetenceStrings = checked
  },
  methods: {
    changeCompetences(): void {
      this.innerUtilisateur = {
        ...this.innerUtilisateur,
        competencesReferentPedagogie: this.checkedCompetenceStrings.includes(
          COMPETENCES_STRINGS.PEDAGOGIE,
        ),
        competencesReferentEcologie: this.checkedCompetenceStrings.includes(
          COMPETENCES_STRINGS.ECOLOGIE,
        ),
        competencesReferentAe: this.checkedCompetenceStrings.includes(COMPETENCES_STRINGS.AE),
      }
    },

    submit(): void {
      this.$emit("update:model-value", this.innerUtilisateur)
    },

    goBack(): void {
      this.$emit("go-back", this.innerUtilisateur)
    },
  },
})
</script>
<style scoped lang="scss">
.buttons {
  justify-content: space-between;
}
</style>
